import React, { useContext, useEffect } from 'react';
import { ApplicationContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { useIsMobileResolution } from '../../../hooks/use-is-mobile-resolution.js';
import { useIsXSmallResolution } from '../../../hooks/use-is-xsmall-resolution.js';
import { Modal } from '../../modal/modal.js';
function LocatorModal(props) {
    const { contextData, fragment, modalType, onClose, onSubmit } = props;
    const applicationContext = useContext(ApplicationContext.Context);
    const isXSmallResolution = useIsXSmallResolution();
    const isMobileResolution = useIsMobileResolution();
    useEffect(() => {
        if (!isMobileResolution) {
            return;
        }
        const popItem = applicationContext.pushNavigationItem(props.onClose);
        return () => popItem();
    }, [isMobileResolution]);
    return (React.createElement(Modal, { closeable: !isXSmallResolution, contextData: contextData, focusOnOpen: false, fragment: fragment, noPadding: isXSmallResolution, onClose: onClose, onSubmit: onSubmit, type: modalType }));
}
export { LocatorModal, };
//# sourceMappingURL=locator-modal.js.map